import styled, { css } from 'styled-components'
import Typography from '@mui/material/Typography'
import { marginHandler, MarginSpacing } from 'commons/styles/spacing'

const StyledTypography = styled(Typography)<{ $margin?: MarginSpacing }>`
  ${marginHandler}

  line-height: ${({ lineHeight }) => `${lineHeight || 1}`};

  ${({ maxWidth }) =>
    maxWidth &&
    css`
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    `}
`

export { StyledTypography }
